'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createUrl = createUrl;
exports.buildRoutes = buildRoutes;

var _path = require('path');

var _urls = require('./urls');

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

function slug(a) {
    return a.replace(/[^a-zA-Z0-9-]/g, '-').replace(/--/g, '-');
}
function createUrl(attributes, path) {
    if (attributes.path) return attributes.path;
    if (/^\.\/index\.md$/.test(path)) return '/';
    path = (0, _path.dirname)(path.replace(/^\.\//, '/')).split('/').map(function (d) {
        return slug(d);
    }).join('/');
    path += '/' + slug(attributes.title);
    path = (0, _path.normalize)(path).toLowerCase();
    return path;
}
function buildRoutes(pages, apiDocs) {
    var routes = void 0;
    if (pages) {
        routes = buildPageRoutes(pages);
        if (apiDocs) {
            routes = routes.concat(buildApiDocsRoutes(apiDocs));
        }
    } else if (apiDocs) {
        routes = [buildApiDocsRoutes(apiDocs), { kind: 'redirect', url: '/', to: (0, _urls.rootUrl)(apiDocs), title: undefined }];
    } else {
        throw 'Neither pages nor apiDocs was provided';
    }
    console.log('routes', routes);
    return routes;
}
function buildPageRoutes(pages) {
    var routes = [];
    var subRoutes = {};
    var subRoutesWithoutIndex = {};
    var hasIndex = false;
    Object.entries(pages).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            path = _ref2[0],
            _ref2$ = _ref2[1],
            attributes = _ref2$.attributes,
            component = _ref2$.default;

        var url = createUrl(attributes, path);
        var urlParts = url.split('/');
        if (urlParts.length === 2) {
            if (url === '/') {
                hasIndex = true;
            }
            routes.push({
                kind: 'page',
                url: url,
                title: attributes.title,
                attributes: attributes,
                component: component
            });
        } else if (urlParts.length === 3) {
            var _path$split = path.split('/'),
                _path$split2 = _slicedToArray(_path$split, 2),
                folder = _path$split2[1];

            if (!subRoutes[folder]) {
                subRoutes[folder] = [];
                subRoutesWithoutIndex[folder] = true;
            }
            if (/index\.md$/.test(path)) {
                url = '/' + folder;
                delete subRoutesWithoutIndex[folder];
                routes.push({
                    kind: 'folder',
                    title: attributes.title,
                    url: url,
                    subPages: subRoutes[folder]
                });
            }
            subRoutes[folder].push({
                url: url,
                title: attributes.title,
                attributes: attributes,
                component: component
            });
        } else {
            throw Error('Nested directories are not supported');
        }
    });
    Object.keys(subRoutesWithoutIndex).forEach(function (folder) {
        routes.push({
            kind: 'folder',
            title: folder,
            url: '/' + folder,
            subPages: subRoutes[folder],
            redirectTo: subRoutes[folder][0].url
        });
    });
    if (!hasIndex) {
        routes.push({ kind: 'redirect', url: '/', title: undefined, to: routes[0].url });
    }
    return routes;
}
function buildApiDocsRoutes(apiDocs) {
    var modules = {};
    var indexModules = {};
    var rootModule = void 0;
    var docsRoot = (0, _urls.rootUrl)(apiDocs);
    console.log('apiDocs.mainModule', apiDocs.data.mainModule);
    Object.values(apiDocs.data.modules).forEach(function (module) {
        var url = (0, _urls.moduleUrl)(module, apiDocs);
        var declarations = Object.keys(module.declarations);
        if (declarations.length === 0 && module.reexports.length === 0 && url !== docsRoot) return;
        console.log('module.outPath', module.outPath);
        var isMain = apiDocs.data.mainModule === module.outPath;
        if (isMain) {
            module.name = apiDocs.data.name;
        }
        var modulePage = {
            title: isMain ? apiDocs.title || _urls.defaultTitle : module.name,
            url: url,
            module: module,
            apiDocs: apiDocs,
            modules: [],
            components: [],
            types: [],
            classes: [],
            functions: [],
            variables: []
        };
        declarations.forEach(function (id) {
            var declaration = module.declarations[id];
            switch (declaration.kind) {
                case 'Component':
                    modulePage.components.push(declaration);
                    break;
                case 'Type':
                    modulePage.types.push(declaration);
                    break;
                case 'Class':
                    modulePage.classes.push(declaration);
                    break;
                case 'Function':
                    modulePage.functions.push(declaration);
                    break;
                case 'Variable':
                    modulePage.variables.push(declaration);
                    break;
            }
        });
        module.reexports.forEach(function (e) {
            var originalModule = apiDocs.data.modules[e.path];
            if (!originalModule) return;
            var declaration = originalModule.declarations[e.id];
            if (!declaration) return;
            declaration = __assign({}, declaration, { reexport: e, name: e.name });
            switch (declaration.kind) {
                case 'Component':
                    modulePage.components.push(declaration);
                    break;
                case 'Type':
                    modulePage.types.push(declaration);
                    break;
                case 'Class':
                    modulePage.classes.push(declaration);
                    break;
                case 'Function':
                    modulePage.functions.push(declaration);
                    break;
                case 'Variable':
                    modulePage.variables.push(declaration);
                    break;
            }
        });
        if (url === docsRoot) {
            rootModule = modulePage;
        } else {
            var dir = (0, _path.dirname)(module.outPath);
            if (modules[dir]) {
                modules[dir].push(modulePage);
            } else {
                modules[dir] = [modulePage];
            }
        }
    });
    var dirs = Object.keys(modules);
    if (dirs.length > 0) {
        var path = dirs[0].split('/');
        console.log('path', path);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var dir = _step.value;

                if (dirs.every(function (d) {
                    return d.startsWith(dir + '/') || d === dir;
                })) {
                    dirs = dirs.map(function (d) {
                        var updatedPath = d.slice(dir.length + 1);
                        modules[updatedPath] = modules[d];
                        delete modules[d];
                        return updatedPath;
                    });
                } else return 'break';
            };

            for (var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ret = _loop();

                if (_ret === 'break') break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        console.log('modules', modules);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var dir = _step2.value;

                var url = void 0,
                    outPath = void 0;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = modules[dir][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var module = _step3.value;

                        if (module.module.outPath.endsWith('/index.js')) {
                            indexModules[dir] = module;
                            break;
                        } else {
                            url = module.url;
                            outPath = module.module.outPath;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                if (indexModules[dir]) {
                    indexModules[dir].modules = indexModules[dir].modules.concat(modules[dir].filter(function (m) {
                        return m.url !== indexModules[dir].url;
                    }));
                    indexModules[dir].title = (0, _path.basename)(dir);
                    indexModules[dir].url = (0, _path.dirname)(url);
                    indexModules[dir].module.name = (0, _path.basename)(dir);
                } else {
                    indexModules[dir] = {
                        title: (0, _path.basename)(dir),
                        url: (0, _path.dirname)(url),
                        module: {
                            name: (0, _path.basename)(dir),
                            srcPath: '',
                            outPath: (0, _path.join)((0, _path.dirname)(outPath), 'index.js'),
                            declarations: {},
                            reexports: []
                        },
                        apiDocs: apiDocs,
                        modules: modules[dir],
                        components: [],
                        types: [],
                        classes: [],
                        functions: [],
                        variables: []
                    };
                }
            };

            for (var _iterator2 = dirs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    console.log('indexModules', indexModules);
    // Sort the keys with longest first first so we visit the most nested path first
    var indexModulePaths = Object.keys(indexModules).sort(function (a, b) {
        return b.length - a.length;
    });
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        var _loop3 = function _loop3() {
            var path = _step4.value;

            // Find the parents and sort them with longest first so that parents[0] is the direct parent
            var parents = indexModulePaths.filter(function (d) {
                return path.startsWith(d + '/');
            }).sort(function (a, b) {
                return b.length - a.length;
            });
            if (parents.length === 0 && path !== '' && indexModules['']) {
                parents.push('');
            }
            if (parents.length > 0) {
                // Push this module into the parents modules and remove it from what will be the root modules
                indexModules[parents[0]].modules.push(indexModules[path]);
                delete indexModules[path];
            }
        };

        for (var _iterator4 = indexModulePaths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            _loop3();
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    console.log('parented', indexModules);
    var rootModules = indexModules[''] ? indexModules[''].modules : Object.values(indexModules);
    if (rootModule) {
        rootModule.modules = rootModules;
        return __assign({ kind: 'module' }, rootModule);
    } else {
        return {
            kind: 'module',
            title: apiDocs.title || _urls.defaultTitle,
            url: docsRoot,
            module: {
                name: apiDocs.data.name,
                srcPath: '',
                outPath: '',
                declarations: {},
                reexports: []
            },
            apiDocs: apiDocs,
            modules: rootModules,
            components: [],
            types: [],
            classes: [],
            functions: [],
            variables: []
        };
    }
}
//# sourceMappingURL=routes.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/lib/routes.js
 ** module id = 488
 ** module chunks = 0
 **/